<template>
  <div class="container" v-if="online_pay">
    <div class="bg-block">
      <div class="mwow-top-title">
        <span class="text">乐沃收银</span>
      </div>
      <div class="total-wrap">
        <div class="item border money">
          <div class="money-box">
            <el-popover
              placement="top"
              popper-class="followuppopover"
              trigger="hover"
              width="150"
            >
              <p>钱包金额=可提现金额+留存金额+冻结金额</p>
              <i class="el-icon-question" slot="reference"></i>
            </el-popover>
            <span style="margin-left: 5px">钱包金额：</span>
            <span>￥{{ account_amount || 0 }}</span>
          </div>
          <div class="money-box">
            <el-popover
              placement="top"
              popper-class="followuppopover"
              trigger="hover"
              width="150"
            >
              <p>
                门店正常运营期间，留存金额不支持提现，用于学员退款周转(目标留存金额为{{
                  withdrawConfig.config
                    ? withdrawConfig.config.retained_amount
                    : "-"
                }}元)
              </p>
              <i class="el-icon-question" slot="reference"></i>
            </el-popover>
            <span style="margin-left: 5px">留存金额：</span>
            <span>￥{{ retained_amount || 0 }}</span>
          </div>
        </div>
        <div class="item border">
          <p class="number">￥{{ withdraw_able_amount }}</p>
          <p class="title">
            可提现金额
            <el-popover
              placement="top"
              popper-class="followuppopover"
              trigger="hover"
              width="150"
            >
              <p>已到账可提现的金额</p>
              <i class="el-icon-question" slot="reference"></i>
            </el-popover>
          </p>
        </div>
        <div class="item border">
          <p class="number">￥{{ freeze_amount }}</p>
          <p class="title">
            冻结金额
            <!-- <el-popover
              placement="top"
              popper-class="followuppopover"
              trigger="hover"
              width="150"
            >
              <p>提现中的金额</p>
              <i class="el-icon-question" slot="reference"></i>
            </el-popover> -->
          </p>
        </div>
        <div
          class="item"
          v-if="
            merchantInfo.withdraw_status === 1 &&
            withdrawConfig.withdraw_auth === 1 &&
            withdrawConfig.config.auto_switch === 2
          "
        >
          <div class="mwow-button-filled success" @click="toWithdrawal">
            我要提现
          </div>
        </div>
      </div>
    </div>
    <div class="bg-block">
      <el-tabs v-model="activeName">
        <el-tab-pane label="收支明细" name="detail">
          <tab-detail v-if="activeName === 'detail'"></tab-detail>
        </el-tab-pane>
        <el-tab-pane label="提现记录" name="log">
          <tab-log v-if="activeName === 'log'"></tab-log>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>

  <div class="container" v-else-if="!online_pay">
    <div class="bg-block">
      <div class="info">
        <!-- <img
            src="https://wowsite.musicwow.com/teaching_system_frontend/images/finance/notOpen.png"
            alt=""
          />
          <div>还未开通乐沃收银</div>
          <div>请联系总部客服工作人员开通</div> -->
        <div class="title">开通乐沃收银</div>
        <div v-html="mainData.content" class="content" v-if="!loading"></div>
      </div>
      <div class="buttons">
        <div class="btn" @click="toAgreement">立即开通</div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getAccountBalanceApi,
  withdrawalInfoApi,
  getMerchantInfoApi,
  applyStatusApi,
  applyClickApi,
  applyDetailApi,
} from "@/api/storeWallet";
import tabDetail from "./tabDetail.vue";
import tabLog from "./tabLog.vue";
import { UserModule } from "@/store/module/user";

export default {
  components: {
    tabDetail,
    tabLog,
  },
  data() {
    return {
      activeName: "detail",
      account_amount: 0, // 钱包金额
      retained_amount: 0, // 留存金额
      withdraw_able_amount: 0, // 可提现金额
      freeze_amount: 0, // 冻结金额
      online_pay: false, // 门店线上支付
      withdrawConfig: {}, // 提现配置信息（提现权限）
      merchantInfo: {}, // 商户信息（所有状态）
      mainData: {},
    };
  },
  created() {
    this.online_pay = UserModule.userInfo.online_pay;
    // 开通线上支付，调取对应金额接口、商户信息
    if (this.online_pay) {
      withdrawalInfoApi().then((res) => {
        if (res.error_code === 0) {
          this.withdrawConfig = res.data;
        }
      });
      getMerchantInfoApi().then((res) => {
        if (res.error_code === 0) {
          this.merchantInfo = res.data;
        }
      });
      getAccountBalanceApi().then((res) => {
        if (res.error_code === 0) {
          this.account_amount = res.data.account_amount; // 账户总金额
          this.retained_amount = res.data.retained_amount; // 留存金额
          this.withdraw_able_amount = res.data.withdraw_able_amount; // 可提现金额
          this.freeze_amount = res.data.freeze_amount; // 冻结金额
        }
      });
    } else {
      // 未开通线上支付，走开通流程，如果提交过支付申请，直接跳转到协助资料页
      applyStatusApi().then((res) => {
        if (res.error_code === 0) {
          if (res.data.cate_id === 3) {
            this.$router.push({
              name: "storeWalletAssistment",
            });
          } else {
            applyDetailApi({
              cate_id: res.data.cate_id,
            }).then((res) => {
              this.mainData = res.data.info;
              // 未开通的门店，都需要要进行点击数上报
              applyClickApi({
                article_id: res.data.info.id,
              }).then(() => {});
            });
          }
        }
      });
    }
  },
  methods: {
    toWithdrawal() {
      this.$router.push({
        name: "storeWalletWithdrawal",
      });
    },
    toAgreement() {
      this.$router.push({
        name: "storeWalletAgreement",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  height: 85vh;
  .bg-block {
    padding: 0 12px 12px 12px;
    background-color: #ffffff;
    border-radius: 4px;
    margin-bottom: 12px;
    .total-wrap {
      display: flex;
      align-items: center;
      padding: 24px 0;
      .item {
        text-align: center;
        flex: 1;
        &.border {
        }
        .number {
          font-size: 24px;
          line-height: 24px;
          margin-bottom: 12px;
          color: #5c5d5e;
        }
        .title {
          font-size: 14px;
          line-height: 14px;
          color: #5c5d5e;
        }
        .el-icon-question {
          margin: 0 0 0 8px;
          color: #bebfc0 !important;
          font-size: 16px;
          vertical-align: text-bottom;
        }
      }
      .money {
        flex: 0.8;
        border-right: 1px solid #bebfc0;
        .money-box {
          font-size: 14px;
          height: 20px;
          line-height: 20px;
          margin: 10px;
        }
      }
    }
    .info {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0 60px;
      .title {
        font-weight: 700;
        font-size: 18px;
        margin: 30px 0;
        color: #303133;
      }
      /deep/.content {
        height: 65vh;
        border: 1px solid #c1c1c1;
        padding: 20px;
        overflow-y: auto;
        p {
          font-size: 16px !important;
        }
        &::-webkit-scrollbar {
          width: 4px;
          height: 8px;
        }
        &::-webkit-scrollbar-track {
          width: 4px;
          background: none;
        }
        &::-webkit-scrollbar-thumb {
          width: 4px;
          background: #c1c1c1;
          border-radius: 4px;
        }
      }
    }
    .buttons {
      margin: 30px 0;
      .btn {
        font-size: 16px;
        margin: 0 auto;
        background: #07d1aa;
        color: white;
        width: 92px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        border-radius: 5px;
      }
      .btn:hover {
        cursor: pointer;
      }
    }
  }
}
</style>
